/* This file was auto-generated with the command "generate-graphql-types" */
import * as Types from '~/graphql/generated/types';

import * as Operations from './mutations';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BookmarkContentMutationVariables = Types.Exact<{
    contentId: Types.Scalars['String']['input'];
    bookmarked: Types.Scalars['Boolean']['input'];
}>;

export type BookmarkContentMutation = { bookmarkContent: boolean };

export type AddToMailchimpAudienceMutationVariables = Types.Exact<{
    email: Types.Scalars['String']['input'];
    locale: Types.Scalars['Locale']['input'];
    mobile?: Types.InputMaybe<Types.Scalars['String']['input']>;
    tags: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input'];
}>;

export type AddToMailchimpAudienceMutation = { addToMailchimpAudience?: { added: boolean } | null };

export type TrackContentProgressMutationVariables = Types.Exact<{
    completed?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
    contentId: Types.Scalars['String']['input'];
    time?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;

export type TrackContentProgressMutation = { trackContentProgress: boolean };

export type AnswerQuestionsMutationVariables = Types.Exact<{
    userAnswers: Array<Types.UserAnswer> | Types.UserAnswer;
}>;

export type AnswerQuestionsMutation = { answerQuestions: boolean };

export type AnswerQuestionMutationVariables = Types.Exact<{
    userAnswer: Types.UserAnswer;
}>;

export type AnswerQuestionMutation = { answerQuestion: boolean };

export type OrderEventMutationVariables = Types.Exact<{
    bookingRequest: Types.BookingRequest;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userId: Types.Scalars['ID']['input'];
}>;

export type OrderEventMutation = {
    orderEvent?: {
        bookingId?: Types.UUID | null;
        totalPrice?: number | null;
        clientReference?: string | null;
        automaticallyCharged?: boolean | null;
    } | null;
};

export type UpdateBookingMutationVariables = Types.Exact<{
    bookingId: Types.Scalars['ID']['input'];
    bookingRequest: Types.BookingRequest;
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;

export type UpdateBookingMutation = { updateBooking: { clientReference?: string | null } };

export type OrderMembershipMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    checkoutSessionId?: Types.InputMaybe<Types.Scalars['String']['input']>;
    membershipOrderRequest: Types.MembershipOrderRequest;
    userId: Types.Scalars['ID']['input'];
}>;

export type OrderMembershipMutation = {
    orderMembership: { clientReference?: string | null; id?: Types.UUID | null };
};

export type PayNotPaidMembershipOrderMutationVariables = Types.Exact<{
    tenantId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
    userMembershipId: Types.Scalars['ID']['input'];
    paymentMethod: Types.PaymentMethod;
}>;

export type PayNotPaidMembershipOrderMutation = {
    payNotPaidMembershipOrder: { clientReference?: string | null; id?: Types.UUID | null };
};

export type EarlyRenewMembershipMutationVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
}>;

export type EarlyRenewMembershipMutation = { earlyRenewMembership: { earlyRenewed: boolean } };

export type CreateReminderConfigMutationVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    createEventReminderInput: Types.CreateReminderConfigInput;
}>;

export type CreateReminderConfigMutation = { createReminderConfig: { id: Types.UUID } };

export type DeleteReminderConfigMutationVariables = Types.Exact<{
    userId: Types.Scalars['ID']['input'];
    reminderConfigId: Types.Scalars['ID']['input'];
}>;

export type DeleteReminderConfigMutation = { deleteReminderConfig: { deleted: boolean } };

export type SetWatchedVideoStatusMutationVariables = Types.Exact<{
    contentMediaId: Types.Scalars['String']['input'];
    isDeleted: Types.Scalars['Boolean']['input'];
}>;

export type SetWatchedVideoStatusMutation = { setWatchedVideoStatus: boolean };

export type TrackContentNotesMutationVariables = Types.Exact<{
    contentMediaId: Types.Scalars['String']['input'];
    notes: Array<Types.NoteInput> | Types.NoteInput;
}>;

export type TrackContentNotesMutation = { trackContentNotes: boolean };

export type BookmarkContentMutationFn = Apollo.MutationFunction<
    BookmarkContentMutation,
    BookmarkContentMutationVariables
>;

/**
 * __useBookmarkContentMutation__
 *
 * To run a mutation, you first call `useBookmarkContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBookmarkContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bookmarkContentMutation, { data, loading, error }] = useBookmarkContentMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *      bookmarked: // value for 'bookmarked'
 *   },
 * });
 */
export function useBookmarkContentMutation(
    baseOptions?: Apollo.MutationHookOptions<
        BookmarkContentMutation,
        BookmarkContentMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<BookmarkContentMutation, BookmarkContentMutationVariables>(
        Operations.bookmarkContent,
        options
    );
}
export type BookmarkContentMutationHookResult = ReturnType<typeof useBookmarkContentMutation>;
export type BookmarkContentMutationResult = Apollo.MutationResult<BookmarkContentMutation>;
export type BookmarkContentMutationOptions = Apollo.BaseMutationOptions<
    BookmarkContentMutation,
    BookmarkContentMutationVariables
>;
export type AddToMailchimpAudienceMutationFn = Apollo.MutationFunction<
    AddToMailchimpAudienceMutation,
    AddToMailchimpAudienceMutationVariables
>;

/**
 * __useAddToMailchimpAudienceMutation__
 *
 * To run a mutation, you first call `useAddToMailchimpAudienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddToMailchimpAudienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addToMailchimpAudienceMutation, { data, loading, error }] = useAddToMailchimpAudienceMutation({
 *   variables: {
 *      email: // value for 'email'
 *      locale: // value for 'locale'
 *      mobile: // value for 'mobile'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useAddToMailchimpAudienceMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AddToMailchimpAudienceMutation,
        AddToMailchimpAudienceMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        AddToMailchimpAudienceMutation,
        AddToMailchimpAudienceMutationVariables
    >(Operations.addToMailchimpAudience, options);
}
export type AddToMailchimpAudienceMutationHookResult = ReturnType<
    typeof useAddToMailchimpAudienceMutation
>;
export type AddToMailchimpAudienceMutationResult =
    Apollo.MutationResult<AddToMailchimpAudienceMutation>;
export type AddToMailchimpAudienceMutationOptions = Apollo.BaseMutationOptions<
    AddToMailchimpAudienceMutation,
    AddToMailchimpAudienceMutationVariables
>;
export type TrackContentProgressMutationFn = Apollo.MutationFunction<
    TrackContentProgressMutation,
    TrackContentProgressMutationVariables
>;

/**
 * __useTrackContentProgressMutation__
 *
 * To run a mutation, you first call `useTrackContentProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackContentProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackContentProgressMutation, { data, loading, error }] = useTrackContentProgressMutation({
 *   variables: {
 *      completed: // value for 'completed'
 *      contentId: // value for 'contentId'
 *      time: // value for 'time'
 *   },
 * });
 */
export function useTrackContentProgressMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TrackContentProgressMutation,
        TrackContentProgressMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<TrackContentProgressMutation, TrackContentProgressMutationVariables>(
        Operations.trackContentProgress,
        options
    );
}
export type TrackContentProgressMutationHookResult = ReturnType<
    typeof useTrackContentProgressMutation
>;
export type TrackContentProgressMutationResult =
    Apollo.MutationResult<TrackContentProgressMutation>;
export type TrackContentProgressMutationOptions = Apollo.BaseMutationOptions<
    TrackContentProgressMutation,
    TrackContentProgressMutationVariables
>;
export type AnswerQuestionsMutationFn = Apollo.MutationFunction<
    AnswerQuestionsMutation,
    AnswerQuestionsMutationVariables
>;

/**
 * __useAnswerQuestionsMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionsMutation, { data, loading, error }] = useAnswerQuestionsMutation({
 *   variables: {
 *      userAnswers: // value for 'userAnswers'
 *   },
 * });
 */
export function useAnswerQuestionsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AnswerQuestionsMutation,
        AnswerQuestionsMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<AnswerQuestionsMutation, AnswerQuestionsMutationVariables>(
        Operations.answerQuestions,
        options
    );
}
export type AnswerQuestionsMutationHookResult = ReturnType<typeof useAnswerQuestionsMutation>;
export type AnswerQuestionsMutationResult = Apollo.MutationResult<AnswerQuestionsMutation>;
export type AnswerQuestionsMutationOptions = Apollo.BaseMutationOptions<
    AnswerQuestionsMutation,
    AnswerQuestionsMutationVariables
>;
export type AnswerQuestionMutationFn = Apollo.MutationFunction<
    AnswerQuestionMutation,
    AnswerQuestionMutationVariables
>;

/**
 * __useAnswerQuestionMutation__
 *
 * To run a mutation, you first call `useAnswerQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerQuestionMutation, { data, loading, error }] = useAnswerQuestionMutation({
 *   variables: {
 *      userAnswer: // value for 'userAnswer'
 *   },
 * });
 */
export function useAnswerQuestionMutation(
    baseOptions?: Apollo.MutationHookOptions<
        AnswerQuestionMutation,
        AnswerQuestionMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<AnswerQuestionMutation, AnswerQuestionMutationVariables>(
        Operations.answerQuestion,
        options
    );
}
export type AnswerQuestionMutationHookResult = ReturnType<typeof useAnswerQuestionMutation>;
export type AnswerQuestionMutationResult = Apollo.MutationResult<AnswerQuestionMutation>;
export type AnswerQuestionMutationOptions = Apollo.BaseMutationOptions<
    AnswerQuestionMutation,
    AnswerQuestionMutationVariables
>;
export type OrderEventMutationFn = Apollo.MutationFunction<
    OrderEventMutation,
    OrderEventMutationVariables
>;

/**
 * __useOrderEventMutation__
 *
 * To run a mutation, you first call `useOrderEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderEventMutation, { data, loading, error }] = useOrderEventMutation({
 *   variables: {
 *      bookingRequest: // value for 'bookingRequest'
 *      tenantId: // value for 'tenantId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrderEventMutation(
    baseOptions?: Apollo.MutationHookOptions<OrderEventMutation, OrderEventMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<OrderEventMutation, OrderEventMutationVariables>(
        Operations.orderEvent,
        options
    );
}
export type OrderEventMutationHookResult = ReturnType<typeof useOrderEventMutation>;
export type OrderEventMutationResult = Apollo.MutationResult<OrderEventMutation>;
export type OrderEventMutationOptions = Apollo.BaseMutationOptions<
    OrderEventMutation,
    OrderEventMutationVariables
>;
export type UpdateBookingMutationFn = Apollo.MutationFunction<
    UpdateBookingMutation,
    UpdateBookingMutationVariables
>;

/**
 * __useUpdateBookingMutation__
 *
 * To run a mutation, you first call `useUpdateBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBookingMutation, { data, loading, error }] = useUpdateBookingMutation({
 *   variables: {
 *      bookingId: // value for 'bookingId'
 *      bookingRequest: // value for 'bookingRequest'
 *      tenantId: // value for 'tenantId'
 *   },
 * });
 */
export function useUpdateBookingMutation(
    baseOptions?: Apollo.MutationHookOptions<UpdateBookingMutation, UpdateBookingMutationVariables>
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(
        Operations.updateBooking,
        options
    );
}
export type UpdateBookingMutationHookResult = ReturnType<typeof useUpdateBookingMutation>;
export type UpdateBookingMutationResult = Apollo.MutationResult<UpdateBookingMutation>;
export type UpdateBookingMutationOptions = Apollo.BaseMutationOptions<
    UpdateBookingMutation,
    UpdateBookingMutationVariables
>;
export type OrderMembershipMutationFn = Apollo.MutationFunction<
    OrderMembershipMutation,
    OrderMembershipMutationVariables
>;

/**
 * __useOrderMembershipMutation__
 *
 * To run a mutation, you first call `useOrderMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMembershipMutation, { data, loading, error }] = useOrderMembershipMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      checkoutSessionId: // value for 'checkoutSessionId'
 *      membershipOrderRequest: // value for 'membershipOrderRequest'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useOrderMembershipMutation(
    baseOptions?: Apollo.MutationHookOptions<
        OrderMembershipMutation,
        OrderMembershipMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<OrderMembershipMutation, OrderMembershipMutationVariables>(
        Operations.orderMembership,
        options
    );
}
export type OrderMembershipMutationHookResult = ReturnType<typeof useOrderMembershipMutation>;
export type OrderMembershipMutationResult = Apollo.MutationResult<OrderMembershipMutation>;
export type OrderMembershipMutationOptions = Apollo.BaseMutationOptions<
    OrderMembershipMutation,
    OrderMembershipMutationVariables
>;
export type PayNotPaidMembershipOrderMutationFn = Apollo.MutationFunction<
    PayNotPaidMembershipOrderMutation,
    PayNotPaidMembershipOrderMutationVariables
>;

/**
 * __usePayNotPaidMembershipOrderMutation__
 *
 * To run a mutation, you first call `usePayNotPaidMembershipOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePayNotPaidMembershipOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [payNotPaidMembershipOrderMutation, { data, loading, error }] = usePayNotPaidMembershipOrderMutation({
 *   variables: {
 *      tenantId: // value for 'tenantId'
 *      userMembershipId: // value for 'userMembershipId'
 *      paymentMethod: // value for 'paymentMethod'
 *   },
 * });
 */
export function usePayNotPaidMembershipOrderMutation(
    baseOptions?: Apollo.MutationHookOptions<
        PayNotPaidMembershipOrderMutation,
        PayNotPaidMembershipOrderMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        PayNotPaidMembershipOrderMutation,
        PayNotPaidMembershipOrderMutationVariables
    >(Operations.payNotPaidMembershipOrder, options);
}
export type PayNotPaidMembershipOrderMutationHookResult = ReturnType<
    typeof usePayNotPaidMembershipOrderMutation
>;
export type PayNotPaidMembershipOrderMutationResult =
    Apollo.MutationResult<PayNotPaidMembershipOrderMutation>;
export type PayNotPaidMembershipOrderMutationOptions = Apollo.BaseMutationOptions<
    PayNotPaidMembershipOrderMutation,
    PayNotPaidMembershipOrderMutationVariables
>;
export type EarlyRenewMembershipMutationFn = Apollo.MutationFunction<
    EarlyRenewMembershipMutation,
    EarlyRenewMembershipMutationVariables
>;

/**
 * __useEarlyRenewMembershipMutation__
 *
 * To run a mutation, you first call `useEarlyRenewMembershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEarlyRenewMembershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [earlyRenewMembershipMutation, { data, loading, error }] = useEarlyRenewMembershipMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useEarlyRenewMembershipMutation(
    baseOptions?: Apollo.MutationHookOptions<
        EarlyRenewMembershipMutation,
        EarlyRenewMembershipMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<EarlyRenewMembershipMutation, EarlyRenewMembershipMutationVariables>(
        Operations.EarlyRenewMembership,
        options
    );
}
export type EarlyRenewMembershipMutationHookResult = ReturnType<
    typeof useEarlyRenewMembershipMutation
>;
export type EarlyRenewMembershipMutationResult =
    Apollo.MutationResult<EarlyRenewMembershipMutation>;
export type EarlyRenewMembershipMutationOptions = Apollo.BaseMutationOptions<
    EarlyRenewMembershipMutation,
    EarlyRenewMembershipMutationVariables
>;
export type CreateReminderConfigMutationFn = Apollo.MutationFunction<
    CreateReminderConfigMutation,
    CreateReminderConfigMutationVariables
>;

/**
 * __useCreateReminderConfigMutation__
 *
 * To run a mutation, you first call `useCreateReminderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReminderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReminderConfigMutation, { data, loading, error }] = useCreateReminderConfigMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      createEventReminderInput: // value for 'createEventReminderInput'
 *   },
 * });
 */
export function useCreateReminderConfigMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateReminderConfigMutation,
        CreateReminderConfigMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<CreateReminderConfigMutation, CreateReminderConfigMutationVariables>(
        Operations.CreateReminderConfig,
        options
    );
}
export type CreateReminderConfigMutationHookResult = ReturnType<
    typeof useCreateReminderConfigMutation
>;
export type CreateReminderConfigMutationResult =
    Apollo.MutationResult<CreateReminderConfigMutation>;
export type CreateReminderConfigMutationOptions = Apollo.BaseMutationOptions<
    CreateReminderConfigMutation,
    CreateReminderConfigMutationVariables
>;
export type DeleteReminderConfigMutationFn = Apollo.MutationFunction<
    DeleteReminderConfigMutation,
    DeleteReminderConfigMutationVariables
>;

/**
 * __useDeleteReminderConfigMutation__
 *
 * To run a mutation, you first call `useDeleteReminderConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReminderConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReminderConfigMutation, { data, loading, error }] = useDeleteReminderConfigMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      reminderConfigId: // value for 'reminderConfigId'
 *   },
 * });
 */
export function useDeleteReminderConfigMutation(
    baseOptions?: Apollo.MutationHookOptions<
        DeleteReminderConfigMutation,
        DeleteReminderConfigMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<DeleteReminderConfigMutation, DeleteReminderConfigMutationVariables>(
        Operations.DeleteReminderConfig,
        options
    );
}
export type DeleteReminderConfigMutationHookResult = ReturnType<
    typeof useDeleteReminderConfigMutation
>;
export type DeleteReminderConfigMutationResult =
    Apollo.MutationResult<DeleteReminderConfigMutation>;
export type DeleteReminderConfigMutationOptions = Apollo.BaseMutationOptions<
    DeleteReminderConfigMutation,
    DeleteReminderConfigMutationVariables
>;
export type SetWatchedVideoStatusMutationFn = Apollo.MutationFunction<
    SetWatchedVideoStatusMutation,
    SetWatchedVideoStatusMutationVariables
>;

/**
 * __useSetWatchedVideoStatusMutation__
 *
 * To run a mutation, you first call `useSetWatchedVideoStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWatchedVideoStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWatchedVideoStatusMutation, { data, loading, error }] = useSetWatchedVideoStatusMutation({
 *   variables: {
 *      contentMediaId: // value for 'contentMediaId'
 *      isDeleted: // value for 'isDeleted'
 *   },
 * });
 */
export function useSetWatchedVideoStatusMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetWatchedVideoStatusMutation,
        SetWatchedVideoStatusMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        SetWatchedVideoStatusMutation,
        SetWatchedVideoStatusMutationVariables
    >(Operations.SetWatchedVideoStatus, options);
}
export type SetWatchedVideoStatusMutationHookResult = ReturnType<
    typeof useSetWatchedVideoStatusMutation
>;
export type SetWatchedVideoStatusMutationResult =
    Apollo.MutationResult<SetWatchedVideoStatusMutation>;
export type SetWatchedVideoStatusMutationOptions = Apollo.BaseMutationOptions<
    SetWatchedVideoStatusMutation,
    SetWatchedVideoStatusMutationVariables
>;
export type TrackContentNotesMutationFn = Apollo.MutationFunction<
    TrackContentNotesMutation,
    TrackContentNotesMutationVariables
>;

/**
 * __useTrackContentNotesMutation__
 *
 * To run a mutation, you first call `useTrackContentNotesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackContentNotesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackContentNotesMutation, { data, loading, error }] = useTrackContentNotesMutation({
 *   variables: {
 *      contentMediaId: // value for 'contentMediaId'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useTrackContentNotesMutation(
    baseOptions?: Apollo.MutationHookOptions<
        TrackContentNotesMutation,
        TrackContentNotesMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<TrackContentNotesMutation, TrackContentNotesMutationVariables>(
        Operations.trackContentNotes,
        options
    );
}
export type TrackContentNotesMutationHookResult = ReturnType<typeof useTrackContentNotesMutation>;
export type TrackContentNotesMutationResult = Apollo.MutationResult<TrackContentNotesMutation>;
export type TrackContentNotesMutationOptions = Apollo.BaseMutationOptions<
    TrackContentNotesMutation,
    TrackContentNotesMutationVariables
>;
